import {defineStore} from 'pinia'
import {useApiRequestStore} from '../../ApiRequestStore/useApiRequestStore'
import {mapResourceSpaceResponseInstance} from '@toolify/client/src/modules/api/singletons/mapResourceSpaceResponseInstance'
import {IUpdateResourceSpaceNameRequestInterfaces} from '@toolify/server/src/controllers/ResourceSpaceController/validators/UpdateResourceSpaceName/types/IUpdateResourceSpaceNameRequestInterfaces'
import {ICreateResourceSpaceRequestInterfaces} from '@toolify/server/src/controllers/ResourceSpaceController/validators/CreateResourceSpace/types/ICreateResourceSpaceRequestInterfaces'
import {IGetResourceSpacesRequestInterfaces} from '@toolify/server/src/controllers/ResourceSpaceController/validators/GetResourceSpace/types/IGetResourceSpacesRequestInterfaces'
import {IDeleteResourceSpaceRequestInterfaces} from '@toolify/server/src/controllers/ResourceSpaceController/validators/DeleteResourceSpace/types/IDeleteResourceSpaceRequestInterfaces'
import {IUpdateResourceSpacePositionRequestInterfaces} from '@toolify/server/src/controllers/ResourceSpaceController/validators/UpdateResourceSpacePosition/types/IUpdateResourceSpacePositionRequestInterfaces'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {IParticularColor} from '@toolify/server/src/services/ColorService/types/IParticularColor'

export const useResourceSpaceApiStore = defineStore('resourceSpaceApi', {
  actions: {
    async getResourceSpaces(
      workspaceId: string,
    ): Promise<IGetResourceSpacesRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {resourceSpaces} = await apiRequestStore.get<IGetResourceSpacesRequestInterfaces>(`/workspace/${workspaceId}/resource-spaces`)
      return {
        resourceSpaces: resourceSpaces.map(activityItem => mapResourceSpaceResponseInstance(activityItem)),
      }
    },

    async createResourceSpace(
      workspaceId: string,
      name?: string,
    ): Promise<ICreateResourceSpaceRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {resourceSpace} = await apiRequestStore.post<ICreateResourceSpaceRequestInterfaces>(`/workspace/${workspaceId}/resource-space`, {
        data: {
          name,
        },
      })
      return {
        resourceSpace: mapResourceSpaceResponseInstance(resourceSpace),
      }
    },

    async updateResourceSpaceName(
      resourceSpaceId: string,
      name: string,
    ): Promise<ICreateResourceSpaceRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {resourceSpace} = await apiRequestStore.put<IUpdateResourceSpaceNameRequestInterfaces>(`/resource-space/${resourceSpaceId}/name`, {
        data: {
          name,
        },
      })
      return {
        resourceSpace: mapResourceSpaceResponseInstance(resourceSpace),
      }
    },

    async patchResourceSpace(
      resourceSpaceId: string,
      payload: { name?: string; iconNameType?: IconNameType | null; particularColor?: IParticularColor },
    ): Promise<IUpdateResourceSpaceNameRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {resourceSpace} = await apiRequestStore.put<IUpdateResourceSpaceNameRequestInterfaces>(`/resource-space/${resourceSpaceId}/name`, {
        data: payload,
      })
      return {
        resourceSpace: mapResourceSpaceResponseInstance(resourceSpace),
      }
    },

    async updateResourceSpacePosition(
      resourceSpaceId: string,
      position: number,
    ): Promise<IUpdateResourceSpacePositionRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {resourceSpaces} = await apiRequestStore.patch<IUpdateResourceSpacePositionRequestInterfaces>(`/resource-space/${resourceSpaceId}/position`, {
        data: {
          position,
        },
      })
      return {
        resourceSpaces: resourceSpaces.map(resourceSpace => mapResourceSpaceResponseInstance(resourceSpace)),
      }
    },

    async deleteResourceSpace(
      resourceSpaceId: string,
      withContent?: boolean,
    ): Promise<IDeleteResourceSpaceRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.delete<IDeleteResourceSpaceRequestInterfaces>(`/resource-space/${resourceSpaceId}`,{
        data: {
          withContent,
        },
      })
    },
  },
})
